import { render, staticRenderFns } from "./EstimatesOldPageTaskItemPriceCalculator.vue?vue&type=template&id=2f9c38a9&"
import script from "./EstimatesOldPageTaskItemPriceCalculator.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageTaskItemPriceCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports